export default __webpack_public_path__ + "static/media/907.1f79bff8.gif";